import React, { useState } from 'react';
import { fileSelect, lincIcon, closeIconTask } from '../../static/svgs';
import { getReportingFiles } from './taskApi';
import { url } from '../../static/env';
import FileMessage from '../documents/FileMessage';

function formatDateShort(d) {
    if (!d) return '';
    const date = new Date(d);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yy = String(date.getFullYear()).slice(-2);
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    return `${dd}.${mm}.${yy} / ${hh}:${min}`;
}

function formatTimeoutWallClock(d) {
    if (!d) return '';
    const s = String(d).trim().replace('T', ' ');
    const datePart = s.slice(0, 10);
    const timePart = s.slice(11, 16);
    if (datePart.length === 10 && timePart.length === 5) {
        const [yyyy, mm, dd] = datePart.split('-');
        if (yyyy && mm && dd) {
            return `${dd}.${mm}.${String(yyyy).slice(-2)} / ${timePart}`;
        }
    }
    return s;
}

function TaskItem({ task, selectedFilter, onTaskClick }) {
    const [reportingFilesModal, setReportingFilesModal] = useState({ open: false, reportingId: null, files: [] });
    const [expandedCommentTaskId, setExpandedCommentTaskId] = useState(null);
    const [taskFilesModalOpen, setTaskFilesModalOpen] = useState(false);
    const [taskFilesForModal, setTaskFilesForModal] = useState(null);
    const [taskFilesModalMode, setTaskFilesModalMode] = useState('user'); // 'user' | 'accountant'
    const [expandedTextTaskId, setExpandedTextTaskId] = useState(null);
    // Проверяем, нужно ли показывать задачу в зависимости от фильтра
    const shouldShow = (selectedFilter === 'inProgress' && !task.finish_date) || 
                       (selectedFilter === 'ready' && task.finish_date);

    const handleOpenReportingFiles = async (reportingId) => {
        try {
            const files = await getReportingFiles(reportingId);
            setReportingFilesModal({ open: true, reportingId, files });
        } catch (error) {
            console.error('Error fetching reporting files:', error);
            setReportingFilesModal({ open: true, reportingId, files: [] });
        }
    };

    const handleCloseReportingFilesModal = () => {
        setReportingFilesModal({ open: false, reportingId: null, files: [] });
    };

    const handleOpenTaskFilesModal = (e, mode) => {
        e.stopPropagation();
        setTaskFilesForModal(task);
        setTaskFilesModalMode(mode || 'user');
        setTaskFilesModalOpen(true);
    };

    const handleCloseTaskFilesModal = () => {
        setTaskFilesModalOpen(false);
        setTaskFilesForModal(null);
        setTaskFilesModalMode('user');
    };

    if (!shouldShow) {
        return null;
    }

    const statusMap = {
        created: 'Создана',
        in_progress: 'Взята в работу',
        completed: 'Выполнена',
    };
    const statusLabel = statusMap[task.status] || (task.finish_date ? 'Выполнена' : 'Создана');
    const executorName = task.task_accountant_name || '';

    return (
        <div 
            style={{ marginTop: '25px' }}
            onClick={() => onTaskClick(task)}
        >
            <div className="task">
                <div style={{ width: '100%', textAlign: 'left' }}>
                    <label className='manrope-bold fs-16'>№{task.id}</label>
                </div>
                <div style={{ width: '100%', textAlign: 'left' }}>
                    <label className='manrope-bold fs-16'>{task.title || 'Без заголовка'}</label>
                </div>
                <div
                    style={{ marginTop: '2px', cursor: 'pointer', width: '100%', textAlign: 'left' }}
                    onClick={(e) => { e.stopPropagation(); setExpandedTextTaskId(prev => prev === task.id ? null : task.id); }}
                >
                    <div className='manrope-bold fs-14' style={{ color: '#6B7280' }}>
                        {expandedTextTaskId === task.id
                            ? (task.text || 'Задача по отчетности')
                            : ((task.text || 'Задача по отчетности').length > 80
                                ? `${(task.text || 'Задача по отчетности').slice(0, 80)}...`
                                : (task.text || 'Задача по отчетности'))}
                    </div>
                    {(task.text || '').length > 80 && (
                        <span style={{ fontSize: '11px', color: '#3262FF', marginTop: '4px', display: 'block' }}>
                            {expandedTextTaskId === task.id ? '▲ Свернуть' : '▼ Показать полностью'}
                        </span>
                    )}
                </div>

                <div className='taskDetails'>
                    <label className='manrope-bold color_grey fs-14'>Статус</label>
                    <label className={'manrope-bold fs-14 ' + (task.status === 'completed' || task.finish_date ? 'color_green' : '')}>
                        {statusLabel}
                    </label>
                </div>
                <div className='taskDetails'>
                    <label className='manrope-bold color_grey fs-14'>Исполнитель</label>
                    <label className='manrope-bold fs-14'>{executorName || 'Не назначен'}</label>
                </div>
                <div className='taskDetails'>
                    <label className='manrope-bold color_grey fs-14'>Дата/время создания</label>
                    <label className='manrope-bold fs-14'>{formatDateShort(task.datetime)}</label>
                </div>

                {task.timeout && !(task.reports && task.reports.length > 0) && (
                    <div className='taskDetails'>
                        <label className='manrope-bold color_grey fs-14'>К какой дате/времени</label>
                        <label className='manrope-bold fs-14'>{formatTimeoutWallClock(task.timeout)}</label>
                    </div>
                )}

                <div className='taskDetails' style={{ marginTop: '5px' }}>
                    <label className='manrope-bold color_grey fs-14'>Файлы задачи</label>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }} onClick={(e) => handleOpenTaskFilesModal(e, 'user')}>
                        {fileSelect}
                        <label className='manrope-bold' style={{ color: '#3262FF', fontSize: '12px' }}>
                            {(task.files || []).filter(f => !f.from_accountant).length}
                        </label>
                    </div>
                </div>

                {(task.finish_date || ((task.files || []).filter(f => f.from_accountant).length > 0) || task.comment) ? (
                    <div
                        style={{
                            marginTop: '8px',
                            backgroundColor: '#E3F2FD',
                            borderRadius: '8px',
                            padding: '10px',
                            border: '1px solid #BBDEFB',
                            width: '100%',
                            boxSizing: 'border-box',
                        }}
                    >
                        {task.finish_date && (
                            <div className='taskDetails'>
                                <label className='manrope-bold color_grey fs-14'>Дата выполнения</label>
                                <label className='manrope-bold fs-14'>
                                    {new Date(task.finish_date).toLocaleDateString()}
                                </label>
                            </div>
                        )}
                        {(task.files || []).filter(f => f.from_accountant).length > 0 && (
                            <div
                                className='taskDetails'
                                style={{ marginTop: '4px', cursor: 'pointer' }}
                                onClick={(e) => handleOpenTaskFilesModal(e, 'accountant')}
                            >
                                <label className='manrope-bold color_grey fs-14'>Файлы бухгалтера</label>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                    {fileSelect}
                                    <label className='manrope-bold' style={{ color: '#3262FF', fontSize: '12px' }}>
                                        {(task.files || []).filter(f => f.from_accountant).length}
                                    </label>
                                </div>
                            </div>
                        )}
                        {task.comment ? (
                            <div
                                style={{ marginTop: '4px', cursor: 'pointer', minWidth: 0 }}
                                onClick={(e) => { e.stopPropagation(); setExpandedCommentTaskId(prev => prev === task.id ? null : task.id); }}
                            >
                                <label className='manrope-bold color_grey fs-14'>Комментарий бухгалтера</label>
                                <div
                                    className='manrope-bold fs-14'
                                    style={{
                                        marginTop: '2px',
                                        wordBreak: 'break-word',
                                        overflowWrap: 'break-word',
                                        whiteSpace: 'pre-wrap',
                                        maxWidth: '100%',
                                    }}
                                >
                                    {expandedCommentTaskId === task.id ? task.comment : (task.comment.length > 80 ? task.comment.slice(0, 80) + '...' : task.comment)}
                                </div>
                                {task.comment.length > 80 && (
                                    <span style={{ fontSize: '11px', color: '#3262FF', marginTop: '4px', display: 'block' }}>
                                        {expandedCommentTaskId === task.id ? 'Нажмите, чтобы свернуть' : 'Нажмите, чтобы раскрыть'}
                                    </span>
                                )}
                            </div>
                        ) : null}
                    </div>
                ) : null}
                {task.reports && task.reports.length > 0 && (
                    <div className='taskDetails' style={{ marginTop: '5px', gap: '20px' }}>
                        
                        <div style={{ marginTop: '10px', flex: 1 }}>
                        <label className='manrope-bold color_grey fs-14' style={{ textAlign: 'left', width: '100%', display: 'block' }}>Отчеты</label>
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr>
                                        <th style={{ textAlign: 'left', padding: '5px', fontSize: '12px', fontWeight: 'bold', color: '#666' }}>Наименование</th>
                                        <th style={{ textAlign: 'center', padding: '5px', fontSize: '12px', fontWeight: 'bold', color: '#666' }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {task.reports.map((report) => (
                                        <tr key={report.id}>
                                            <td style={{ textAlign: 'left', padding: '5px', fontSize: '12px' }}>
                                                <span className='manrope-bold' style={{ color: '#3262FF', textAlign: 'left' }}>
                                                    {report.reporting_service_name}
                                                </span>
                                            </td>
                                            <td style={{ textAlign: 'center', padding: '5px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '8px' }}>
                                                    {report.need_submit && (
                                                        <span style={{ 
                                                            fontSize: '12px',
                                                            color: '#3262FF',
                                                            fontWeight: 'bold'
                                                        }}>Сдать</span>
                                                    )}
                                                    <div 
                                                        style={{ 
                                                            cursor: 'pointer', 
                                                            display: 'flex', 
                                                            alignItems: 'center',
                                                            opacity: (report.files_count && report.files_count > 0) ? 1 : 0.5
                                                        }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleOpenReportingFiles(report.id);
                                                        }}
                                                    >
                                                        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path 
                                                                d="M11.0001 5.33337L5.66679 10.6667C4.93041 11.4031 4.93041 12.597 5.66679 13.3334C6.40317 14.0698 7.59707 14.0698 8.33345 13.3334L13.6668 8.00004C15.1396 6.52728 15.1395 4.13946 13.6668 2.6667C12.194 1.19394 9.80621 1.19394 8.33345 2.6667L3.00012 8.00004C0.790976 10.2092 0.790978 13.7909 3.00012 16C5.20926 18.2092 8.79098 18.2092 11.0001 16L16.3335 10.6667" 
                                                                stroke={(report.files_count && report.files_count > 0) ? '#3262FF' : '#000000'} 
                                                                strokeWidth="1.5" 
                                                                strokeLinecap="round" 
                                                                strokeLinejoin="round" 
                                                            />
                                                        </svg>
                                                    </div>
                                                    <div 
                                                        style={{ 
                                                            cursor: report.link && report.link.trim() ? 'pointer' : 'default', 
                                                            display: 'flex', 
                                                            alignItems: 'center',
                                                            opacity: report.link && report.link.trim() ? 1 : 0.5
                                                        }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            if (report.link && report.link.trim()) {
                                                                window.open(report.link, '_blank', 'noopener,noreferrer');
                                                            }
                                                        }}
                                                    >
                                                        <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path 
                                                                d="M9.16488 17.6505C8.92513 17.8743 8.73958 18.0241 8.54996 18.1336C7.62175 18.6695 6.47816 18.6695 5.54996 18.1336C5.20791 17.9361 4.87912 17.6073 4.22153 16.9498C3.56394 16.2922 3.23514 15.9634 3.03767 15.6213C2.50177 14.6931 2.50177 13.5495 3.03767 12.6213C3.23514 12.2793 3.56394 11.9505 4.22153 11.2929L7.04996 8.46448C7.70755 7.80689 8.03634 7.47809 8.37838 7.28062C9.30659 6.74472 10.4502 6.74472 11.3784 7.28061C11.7204 7.47809 12.0492 7.80689 12.7068 8.46448C13.3644 9.12207 13.6932 9.45086 13.8907 9.7929C14.4266 10.7211 14.4266 11.8647 13.8907 12.7929C13.7812 12.9825 13.6314 13.1681 13.4075 13.4078M10.5919 10.5922C10.368 10.8319 10.2182 11.0175 10.1087 11.2071C9.57284 12.1353 9.57284 13.2789 10.1087 14.2071C10.3062 14.5492 10.635 14.878 11.2926 15.5355C11.9502 16.1931 12.279 16.5219 12.621 16.7194C13.5492 17.2553 14.6928 17.2553 15.621 16.7194C15.9631 16.5219 16.2919 16.1931 16.9495 15.5355L19.7779 12.7071C20.4355 12.0495 20.7643 11.7207 20.9617 11.3787C21.4976 10.4505 21.4976 9.30689 20.9617 8.37869C20.7643 8.03665 20.4355 7.70785 19.7779 7.05026C19.1203 6.39267 18.7915 6.06388 18.4495 5.8664C17.5212 5.3305 16.3777 5.3305 15.4495 5.8664C15.2598 5.97588 15.0743 6.12571 14.8345 6.34955" 
                                                                stroke={report.link && report.link.trim() ? '#3262FF' : '#000000'} 
                                                                strokeWidth="2" 
                                                                strokeLinecap="round" 
                                                            />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
            {/* Модалка «Файлы задачи» */}
            {taskFilesModalOpen && taskFilesForModal && (
                <div
                    className="modal-container"
                    onClick={(e) => {
                        if (e.target.className === 'modal-container') handleCloseTaskFilesModal();
                    }}
                >
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="close-button" onClick={handleCloseTaskFilesModal}>
                            {closeIconTask}
                        </div>
                        <div style={{ textAlign: 'center', marginBottom: '20px' }} className="manrope-bold color_blue_1 fs-20">
                            {taskFilesModalMode === 'accountant' ? 'Файлы бухгалтера' : 'Файлы задачи'}
                        </div>
                        <div style={{ minHeight: '200px', maxHeight: '500px', overflowY: 'auto' }}>
                            {(() => {
                                const files = taskFilesForModal.files || [];
                                const userFiles = files.filter(f => !f.from_accountant);
                                const accountantFiles = files.filter(f => f.from_accountant);
                                const showUser = taskFilesModalMode === 'user';
                                const showAccountant = taskFilesModalMode === 'accountant';
                                const list = showUser ? userFiles : accountantFiles;
                                const hasAny = list.length > 0;
                                if (!hasAny) {
                                    return (
                                        <div style={{ textAlign: 'center', color: '#94A3B8', marginTop: '24px' }}>
                                            {showAccountant ? 'Нет файлов от бухгелтерии' : 'Нет прикреплённых файлов'}
                                        </div>
                                    );
                                }
                                return (
                                    <>
                                        {showUser && (
                                            <>
                                                <div style={{ fontSize: '14px', color: '#94A3B8', marginBottom: '10px' }}>Текущие файлы:</div>
                                                <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '16px', gap: '8px' }}>
                                                    {userFiles.filter(f => f.path && f.path.match(/\.(jpg|jpeg|png|gif)$/i)).map((file, index) => (
                                                        <a
                                                            key={`uf-img-${index}`}
                                                            href={`${url}/${file.path}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ cursor: 'pointer' }}
                                                        >
                                                            <img
                                                                src={`${url}/${file.path}`}
                                                                alt=""
                                                                style={{ width: '48px', height: '48px', borderRadius: '8px', objectFit: 'cover' }}
                                                            />
                                                        </a>
                                                    ))}
                                                </div>
                                                {userFiles.filter(f => !f.path || !f.path.match(/\.(jpg|jpeg|png|gif)$/i)).map((file, index) => (
                                                    <div key={`uf-${index}`} style={{ marginBottom: '8px' }}>
                                                        <FileMessage path={file.path} size={file.size} fileAction='choice' />
                                                    </div>
                                                ))}
                                            </>
                                        )}
                                        {showAccountant && (
                                            <>
                                                <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '16px', gap: '8px' }}>
                                                    {accountantFiles.filter(f => f.path && f.path.match(/\.(jpg|jpeg|png|gif)$/i)).map((file, index) => (
                                                        <a
                                                            key={`af-img-${index}`}
                                                            href={`${url}/${file.path}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{ cursor: 'pointer', border: '2px solid #1565C0', borderRadius: '8px', overflow: 'hidden' }}
                                                        >
                                                            <img
                                                                src={`${url}/${file.path}`}
                                                                alt=""
                                                                style={{ width: '48px', height: '48px', borderRadius: '6px', objectFit: 'cover' }}
                                                            />
                                                        </a>
                                                    ))}
                                                </div>
                                                {accountantFiles.filter(f => !f.path || !f.path.match(/\.(jpg|jpeg|png|gif)$/i)).map((file, index) => (
                                                    <div key={`af-${index}`} style={{ marginBottom: '8px', backgroundColor: '#E3F2FD', padding: '8px', borderRadius: '8px' }}>
                                                        <FileMessage path={file.path} size={file.size} fileAction='choice' />
                                                    </div>
                                                ))}
                                            </>
                                        )}
                                    </>
                                );
                            })()}
                        </div>
                    </div>
                </div>
            )}
            {/* Модалка для файлов отчетности */}
            {reportingFilesModal.open && (
                <div 
                    className="modal-container"
                    onClick={(e) => {
                        if (e.target.className === 'modal-container') {
                            handleCloseReportingFilesModal();
                        }
                    }}
                >
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="close-button" onClick={handleCloseReportingFilesModal}>
                            {closeIconTask}
                        </div>
                        <div style={{ textAlign: 'center', marginBottom: '20px' }} className='manrope-bold color_blue_1 fs-20'>
                            Файлы отчетности
                        </div>
                        <div style={{ minHeight: '300px', maxHeight: '500px', overflowY: 'auto' }}>
                            {reportingFilesModal.files.length > 0 ? (
                                <div>
                                    {/* Картинки в ряд */}
                                    <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '10px', gap: '8px' }}>
                                        {reportingFilesModal.files
                                            .filter(file => file.path && file.path.match(/\.(jpg|jpeg|png|gif)$/i))
                                            .map((file, index) => (
                                                <a
                                                    key={`reporting-img-${index}`}
                                                    href={`${url}/${file.path}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <img
                                                        src={`${url}/${file.path}`}
                                                        alt={`File ${index}`}
                                                        style={{ width: '40px', height: '40px', borderRadius: '7px', objectFit: 'cover' }}
                                                    />
                                                </a>
                                            ))}
                                    </div>
                                    {/* Файлы столбиком */}
                                    {reportingFilesModal.files
                                        .filter(file => !file.path || !file.path.match(/\.(jpg|jpeg|png|gif)$/i))
                                        .map((file, index) => (
                                            <div
                                                key={`reporting-file-${index}`}
                                                style={{
                                                    marginBottom: '5px',
                                                }}
                                            >
                                                <FileMessage path={file.path} size={file.size} fileAction='choice' />
                                            </div>
                                        ))}
                                </div>
                            ) : (
                                <div style={{ textAlign: 'center', color: '#94A3B8', marginTop: '50px' }}>
                                    Файлы не найдены
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default TaskItem;

